import { callApi, Controller } from './useApi';

export interface Produzent {
    nr: number;
    name: string;
}

export const defaultProduzent: Produzent = {
    nr: 0,
    name: '',
};

export async function addProduzent(produzent: Produzent): Promise<void> {
    return callApi<void>(Controller.produzent + '/add', { produzent });
}

export async function updateProduzent(produzent: Produzent): Promise<void> {
    return callApi<void>(Controller.produzent + '/update', { produzent });
}

export async function deleteProduzent(produzent: Produzent): Promise<void> {
    return callApi<void>(Controller.produzent + '/update', { produzent });
}
